import React, {createContext, useContext, useMemo} from 'react';

import {usePart} from '../../state/views/hooks';
import {useRunSetProject} from '../../state/views/runSet/hooks';
import {Ref as RunSetRef, RunSetPart} from '../../state/views/runSet/types';

export type RunSelectorRunSetContextType = {
  runSet: RunSetPart;
  ref: RunSetRef;
} | null;

/**
 * @deprecated Use in unit tests only please. For application code, use the
 *             higher-level hooks in this file instead.
 */
export const RunSelectorRunSetContext =
  createContext<RunSelectorRunSetContextType | null>(null);

type RunSelectorRunSetContextProviderProps = {
  children: React.ReactNode;
  runSetRef: RunSetRef;
};

export function RunSelectorRunSetProvider({
  children,
  runSetRef,
}: RunSelectorRunSetContextProviderProps) {
  const runSet = usePart(runSetRef);

  const value = useMemo(
    () => ({
      runSet,
      ref: runSetRef,
    }),
    [runSet, runSetRef]
  );

  return (
    <RunSelectorRunSetContext.Provider value={value}>
      {children}
    </RunSelectorRunSetContext.Provider>
  );
}

export function useCurrentRunSetRef() {
  const val = useContext(RunSelectorRunSetContext);

  if (!val) {
    throw new Error('Unexpected empty run set info in provider');
  }
  return val.ref;
}

export function useCurrentRunSet() {
  const val = useContext(RunSelectorRunSetContext);

  if (!val) {
    throw new Error('Unexpected empty run set info in provider');
  }
  return val.runSet;
}

export function useRunSelectorProjectInfo() {
  const runSet = useCurrentRunSet();
  return useRunSetProject(runSet.project);
}
